import { MutationTree } from "vuex";

import { IntegrationState } from "../types";

const mutations: MutationTree<IntegrationState> = {
  setPublicKey(state, publicKey) {
    state.publicKey = publicKey;
  },
  setSecretKey(state, secretKey) {
    state.secretKey = secretKey;
  },
};

export default mutations;
